import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingAriaLabel: {
    id: 'neptune.Button.loadingAriaLabel',
    defaultMessage: 'loading',
    description: 'Description of button while loading',
  },
});
